import { Link } from "react-router-dom";
import "./NavOptions.css";
import { squares } from "../constants/Home";

const NavOptions = () => {
  return (
    <div className="squares-menu">
      {squares.map(({ name, path, img }) => (
        <Link to={path} className="square" key={name}>
          <div
            className="square-bg"
            style={{ backgroundImage: `url(${img})` }}
          ></div>

          <div className="square-content">
            <p className="square-label">{name}</p>
            <button className="square-button">→</button>
          </div>
        </Link>
      ))}
    </div>
  );
};

export default NavOptions;
